import React, { useContext, useEffect, useState } from 'react';
import Application from '../../../StateContext/Application';

const PurchaseList = () => {
  const statecalls = useContext(Application);
  const { PurchaseList } = statecalls;

  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    vendorName: '',
    poNumber: '',
    poDate: '',
    productName: '',
    quantity: '',
    uom: '',
    remark: '',
  });
  const [editId, setEditId] = useState(null);

  const getAllData = async () => {
    const response = await PurchaseList("get");
    if (response && Array.isArray(response)) {
      setData(response);
      console.log("Set data:", response);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const Submit = async (e) => {
    e.preventDefault();
    console.log("Form submitted", formData);

    if (editId) {
      const response = await PurchaseList("update", { ID: editId, ...formData });
      console.log("Update response:", response);
      if (response?.message === "success") {
        getAllData();
        setFormData({
          vendorName: '',
          poNumber: '',
          poDate: '',
          productName: '',
          quantity: '',
          uom: '',
          remark: '',
        });
        setEditId(null);
      }
    } else {
      const response = await PurchaseList("insert", formData);
      console.log("Insert response:", response);
      if (response?.message === "success") {
        getAllData();
        setFormData({
          vendorName: '',
          poNumber: '',
          poDate: '',
          productName: '',
          quantity: '',
          uom: '',
          remark: '',
        });
      }
    }
  };

  const handleEdit = (item) => {
    setFormData({
      vendorName: item.vendorName,
      poNumber: item.poNumber,
      poDate: item.poDate,
      productName: item.productName,
      quantity: item.quantity,
      uom: item.uom,
      remark: item.remark,
    });
    setEditId(item.ID);
    console.log("edit id", item.ID);
  };
  const handleDelete = async (e, ID) => {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete?")) {
      const response = await PurchaseList("delete", { ID });
      if (response?.message === "success") {
        getAllData();
      }
    }
  };
  return (
    <div>
      <form onSubmit={Submit} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ marginTop: 20, display: 'grid', gap: '2rem', width: '40vw', boxShadow: '0px 0px 10px', padding: '30px', backgroundColor: 'white', borderRadius: '10px' }}>
          <h5>{editId ? "Edit Product" : "Add new purchase"}</h5>
          <div>
            <label className='form-label'>Vendor Name</label>
            <input type='text' className='form-control' name="vendorName" value={formData.vendorName} onChange={handleChange} />
          </div>
          <div>
            <label className='form-label'>PO Number</label>
            <input type='number' className='form-control' name="poNumber" value={formData.poNumber} onChange={handleChange} />
          </div>
          <div>
            <label className='form-label'>PO Date</label>
            <input type='date' className='form-control' name="poDate" value={formData.poDate} onChange={handleChange} />
          </div>
          <div>
            <label className='form-label'>Product Name</label>
            <input type='text' className='form-control' name="productName" value={formData.productName} onChange={handleChange} />
          </div>
          <div>
            <label className='form-label'>Quantity</label>
            <input type='text' className='form-control' name="quantity" value={formData.quantity} onChange={handleChange} />
          </div>
          <div>
            <label className='form-label'>UOM</label>
            <input type='text' className='form-control' name="uom" value={formData.uom} onChange={handleChange} />
          </div>
          <div>
            <label className='form-label'>Remark</label>
            <input type='text' className='form-control' name="remark" value={formData.remark} onChange={handleChange} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem' }}>
  {editId ? (
    <>
      <button
        type="submit"
        style={{
          backgroundColor: '#28a745',
          width: '6rem',
          height: '2rem',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
        }}
      >
        Update
      </button>
      <button
        type="button"
        onClick={() => {
          setEditId(null);
          setFormData({
            vendorName: '',
            poNumber: '',
            poDate: '',
            productName: '',
            quantity: '',
            uom: '',
            remark: '',
          });
        }}
        style={{
          backgroundColor: '#6c757d',
          width: '6rem',
          height: '2rem',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
        }}
      >
        Cancel
      </button>
    </>
  ) : (
    <button
      type="submit"
      style={{
        backgroundColor: 'red',
        width: '6rem',
        height: '2rem',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
      }}
    >
      Submit
    </button>
  )}
</div>

        </div>
      </form>

      <div style={{ display: 'grid', justifyContent: 'center', padding: "20px 0px 0px 0px" }}>
        <div style={{ display: 'flex', justifyContent: 'center', width: '70vw' }}>
          <table style={{ backgroundColor: '#e8f7f3', width: '100%', borderRadius: '10px', overflow: 'hidden' }}>
            <thead>
              <tr style={{ backgroundColor: '#ece9fe', color: 'black', height: '2.5rem' }}>
                <th>Sr.No</th>
                <th>Product Name</th>
                <th>Part Code</th>
                <th>Bin Numbers</th>
                <th>Size</th>
                <th>Min Stock Level</th>
                <th>Max Stock Level</th>
                <th>UOM</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr key={item.ID || index}>
                  <td>{index + 1}</td>
                  <td>{item.vendorName}</td>
                  <td>{item.poNumber}</td>
                  <td>{item.poDate}</td>
                  <td>{item.productName}</td>
                  <td>{item.quantity}</td>
                  <td>{item.uom}</td>
                  <td>{item.remark}</td>
                  <td style={{ padding: '5px' }}>
                    <button onClick={() => handleEdit(item)} className="btn btn-custom-edit" style={{ width: '5rem', border: '1px solid #502eff', backgroundColor: 'white', borderRadius: '5px', padding: '5px', fontSize: '14px', color: '#502eff', fontWeight: '700' }}> Edit</button>
                    <button onClick={(e) => handleDelete(e, item.ID)} className="btn btn-custom-delete" style={{ width: '6rem', border: '1px solid #ee5d50', backgroundColor: 'white', borderRadius: '5px', padding: '5px', marginLeft: '10px', color: '#ee5d50', fontSize: '14px', fontWeight: '700' }}> Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PurchaseList;
